import { Injectable } from '@angular/core';
import {
  UserPasswordModel,
  UpdateUserModel,
  CreationUserPayloadModel,
  UserProfile,
  AssignUserRoleModel,
  ResendInviteModel,
} from '@core/models';
import { ApiService } from '@core/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private readonly apiService: ApiService) {}

  updateUser(user: UpdateUserModel, oid: string): Observable<any> {
    return this.apiService.put(`/users/${oid}`, user as any);
  }
  deleteUserFromPartner(partnerOid: string, userOid: string): Observable<Object> {
    return this.apiService.delete(`/users/${partnerOid}/${userOid}`);
  }
  resendInvite(payload: ResendInviteModel): Observable<Object> {
    return this.apiService.post(`/users/resend-invite`, payload);
  }
  assignUserRole(payload: AssignUserRoleModel): Observable<void> {
    return this.apiService.post(
      `/users/${payload.userObjectId}/groups/${payload.partnerObjectId}/roles/${payload.roleId}`,
    );
  }

  changeUserPassword(payload: UserPasswordModel): Observable<any> {
    return this.apiService.put(`/users/me/password`, payload as any);
  }

  changeUserNotifications(payload: any): Observable<any> {
    return this.apiService.put(`/users/me/notifications`, payload);
  }

  add2FA(payload: any): Observable<any> {
    return this.apiService.put(`/users/me/2fa`, payload);
  }

  createUser(payload: CreationUserPayloadModel): Observable<any> {
    return this.apiService.post('/users', payload as any);
  }

  getUser(oid: string): Observable<UserProfile> {
    return this.apiService.get(`/users/${oid}`);
  }

  getUserAvatar(oid: string): Observable<Blob> {
    return this.apiService.getImgBlob(`/users/${oid}/avatar`);
  }

  updateUserAvatar(file: any, oid: string): Observable<Blob> {
    const formData = new FormData();

    formData.append('avatar', file);
    return this.apiService.put(`/users/${oid}/avatar`, formData);
  }

  switchUser(oid: string, partnerOid: string): Observable<UserProfile> {
    return this.apiService.put(`/users/${oid}/switch/${partnerOid}`);
  }
}
